import DOMPurify from 'dompurify'
import powertoolsLogo from 'img/whiteTcgPowertools.png'
import './static-page.css'

// Matches the formats the static-page rich-text editor can emit (header/bold/italic/underline/
// list/link/image), so editors only ever worry about content — never the surrounding template.
const SANITIZE_OPTIONS = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'h1', 'h2', 'h3', 'ul', 'ol', 'li', 'a', 'img'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'width', 'height', 'class'],
}

interface StaticPageTemplateProps {
  html: string
}

// Generic, branded presentation for collaborator-authored pages, modelled on the transactional
// email layout (app/views/layouts/mailer.html.erb): a Powertools header and footer wrap the
// sanitized content in a centered card, so every page looks like part of the product without the
// editor ever touching the template. The header track shares the card's responsive width, so the
// logo lines up with the card's left edge like on the marketing site.
export const StaticPageTemplate = ({ html }: StaticPageTemplateProps): JSX.Element => {
  const sanitized = DOMPurify.sanitize(html, SANITIZE_OPTIONS)

  return (
    <div className="static-page">
      <header className="static-page__header">
        <div className="static-page__header-inner">
          <a className="static-page__brand" href="https://tcgpowertools.com">
            <img src={powertoolsLogo} alt="TCG PowerTools" />
          </a>
        </div>
      </header>

      <article
        className="static-page__container"
        // eslint-disable-next-line @typescript-eslint/naming-convention
        dangerouslySetInnerHTML={{ __html: sanitized }}
      />

      <footer className="static-page__footer">
        © {new Date().getFullYear()} TCG PowerTools — All rights reserved.
      </footer>
    </div>
  )
}
